import type { ResolvedRoutesConfig } from "typings";

type Routes = { routes?: { path?: string; routes?: Routes[] }[] };

export function listChildRoutes(
  resolvedRoutes: ResolvedRoutesConfig,
  pathname: string
): string[] {
  return (
    ((resolvedRoutes?.routes[0] as Routes)?.routes[0] as Routes)?.routes
      ?.find((app) => app?.path === pathname)
      ?.routes.map((app) => app?.routes)
      ?.flat()
      ?.map((props) => props?.path)
      ?.filter((el) => !!el) || []
  );
}
